<template>
  <div class="decline-project">
    <v-dialog v-model="dialog" max-width="450" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h5 class="black--text">
              Decline to quote {{ rfq.project.name }}?
            </h5>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <h5 class="black--text mb-2">Decline to quote project?</h5>

            <v-textarea
              v-model="message"
              label="Send a reason for declining?"
              rows="3"
              outlined
            ></v-textarea>

            <v-btn
              color="red"
              class="white--text mr-1"
              depressed
              :loading="loading"
              @click="declineProject"
              >Decline</v-btn
            >
            <v-btn
              color="black"
              outlined
              depressed
              :disabled="loading"
              @click="$emit('close')"
              >Cancel</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    rfq: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      message: null
    };
  },
  methods: {
    declineProject() {
      const payload = {
        id: this.rfq.id,
        message: this.message
      }
      this.loading = true;
      this.$store
        .dispatch("rfq/declineRFQ", payload)
        .then(() => {
          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
